import request from '@/utils/request';

export default {
  getList(params) {
    return request({ url: '/implementInfo',method: 'get', params });
  },
  getDetailById(id) {
    return request({ url: '/implementInfo/detail?id='+id });
  },

  apiUpdate(data) {
    return request({ url: '/implementInfo/update',method: 'post', data });
  },
  apiCreate(data) {
    return request({ url: '/implementInfo/create',method: 'post', data });
  },
  apiRemove(data) {
    return request({ url: '/implementInfo/remove',method: 'post', data });
  },
  
  
};
